import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages';
import UploadDocPage from './pages/upload-docs';
import SubmissionCompletedPage from './pages/submission-completed';

function App() {
    return (
        <Router>
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/upload-docs" element={<UploadDocPage />} />
                <Route path="/submission-completed" element={<SubmissionCompletedPage />} />
            </Routes>
        </Router>
    );
}

export default App;